/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationOwnerDTO } from './OrganizationOwnerDTO';
import {
    OrganizationOwnerDTOFromJSON,
    OrganizationOwnerDTOFromJSONTyped,
    OrganizationOwnerDTOToJSON,
} from './OrganizationOwnerDTO';

/**
 * 
 * @export
 * @interface OrganizationOwnerListDTO
 */
export interface OrganizationOwnerListDTO {
    /**
     * 
     * @type {Array<OrganizationOwnerDTO>}
     * @memberof OrganizationOwnerListDTO
     */
    admins: Array<OrganizationOwnerDTO>;
}

/**
 * Check if a given object implements the OrganizationOwnerListDTO interface.
 */
export function instanceOfOrganizationOwnerListDTO(value: object): value is OrganizationOwnerListDTO {
    if (!('admins' in value) || value['admins'] === undefined) return false;
    return true;
}

export function OrganizationOwnerListDTOFromJSON(json: any): OrganizationOwnerListDTO {
    return OrganizationOwnerListDTOFromJSONTyped(json, false);
}

export function OrganizationOwnerListDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationOwnerListDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'admins': ((json['admins'] as Array<any>).map(OrganizationOwnerDTOFromJSON)),
    };
}

export function OrganizationOwnerListDTOToJSON(value?: OrganizationOwnerListDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'admins': ((value['admins'] as Array<any>).map(OrganizationOwnerDTOToJSON)),
    };
}

